import { computed } from 'vue';
import { useUserStore } from '/@/store/modules/user';

export function useOrganizationId(specialId: undefined | number | number[] | null = null): {
  organizationId: number | undefined;
  isSpecialOrganizationId: boolean | undefined;
} {
  const { userInfo } = useUserStore();

  const organizationId = userInfo?.organizationId;

  const isSpecialOrganizationId = computed(() => {
    if (specialId === null || specialId === undefined) {
      return organizationId === specialId;
    }
    if (Array.isArray(specialId)) {
      return specialId.includes(organizationId as number);
    }
    return organizationId === specialId;
  });

  return {
    organizationId,
    isSpecialOrganizationId: isSpecialOrganizationId.value,
  };
}
